<h3 class="mr-3 px-10 pt-5">Title insurance</h3>
<app-residential-fct
	*ngIf="propertyUsage === usageType.RESIDENTIAL"
></app-residential-fct>
<app-commercial-fct
	class="h-full"
	*ngIf="propertyUsage === usageType.COMMERCIAL"
></app-commercial-fct>
